<template>
  <div>
    <b-modal
      title="DETALHES DO REAJUSTE"
      id="last_releases"
      size="md"
      hide-footer
      no-close-on-backdrop
    >
      <div class="row" v-if="last_releases_item">
        <div
          class="
            col-md-12
            pt-0
            pb-0
            border-bottom
            pb-2
            d-flex
            align-items-center
          "
        >
          <label class="m-0 mr-2">EXECUTADO?:</label>
          <div
            v-if="last_releases_item.executed == 1"
            class="d-flex align-items-center"
          >
            <span>SIM</span>
            <v-icon class="ml-2 c-success"> mdi-check-circle-outline </v-icon>
          </div>
          <div v-else class="d-flex align-items-center">
            <span>NÃO</span>
            <v-icon class="ml-2 c-warning"> mdi-information-outline </v-icon>
          </div>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">SERVIÇO:</label>
          <h6 class="m-0">{{ last_releases_item.service_description }}</h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">O QUE VAI ALTEAR?:</label>
          <h6 class="m-0">{{ last_releases_item.change }}</h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">CUSTO ATUAL:</label>
          <h6 class="m-0">
            R$ {{ formatPrice(last_releases_item.old_cost_value) }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">NOVO CUSTO:</label>
          <h6 class="m-0">
            R$ {{ formatPrice(last_releases_item.cost_value) }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">LUCRO(%) ATUAL:</label>
          <h6 class="m-0">{{ last_releases_item.old_profit }}</h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">NOVO LUCRO(%):</label>
          <h6 class="m-0">{{ last_releases_item.profit }}</h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">LUCRO ATUAL:</label>
          <h6 class="m-0">
            R$ {{ formatPrice(last_releases_item.old_sale_value) }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">NOVO LUCRO:</label>
          <h6 class="m-0">
            R$ {{ formatPrice(last_releases_item.sale_value) }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">DATA DO REAJUSTE:</label>
          <h6 class="m-0">
            {{ moment(last_releases_item.date).format("DD/MM/YYYY") }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">QUEM FEZ:</label>
          <h6 class="m-0">
            {{
              professionalClassCouncilValue({
                id: last_releases_item.user_professional_class_council_id,
                name: last_releases_item.user_name,
                profile: last_releases_item.user_profile_name,
                office: last_releases_item.user_office,
                cpf: last_releases_item.user_cpf,
                value: last_releases_item.user_professional_class_council_value,
              })
            }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">QUANDO FOI CRIADO:</label>
          <h6 class="m-0">
            {{
              moment(last_releases_item.created_at).format(
                "DD/MM/YYYY HH:mm:ss"
              )
            }}
          </h6>
        </div>
        <div
          class="col-md-12 text-right"
          v-if="last_releases_item.executed == 0"
        >
          <confirmation-dialog
            v-show="permission('remove', 'readjustment_service')"
            :disabled="loadingDelete"
            message-title="EXCLUIR?"
            message-body="Deseja realmente excluir o reajuste?"
            open-class="btn-cancel"
            open-left-icon="fa-times"
            open-text="EXCLUIR"
            @yes="deleteReadjustment"
          />
        </div>
      </div>
    </b-modal>
    <div
      v-show="permission('write', 'readjustment_service')"
      class="row v-clean mt-2"
    >
      <div class="col-md-12">
        <v-select-default
          item-text="description"
          item-value="id"
          :items="services"
          label="SERVIÇO"
          @change="handleChangeServiceId"
          return-object
        />
      </div>
    </div>
    <div
      v-show="permission('write', 'readjustment_service')"
      class="row v-clean mt-2"
    >
      <div class="col-md-12">
        <h1 class="title-pages">SERVIÇO</h1>
        <div class="row">
          <div class="col-md-4">
            <v-text-field-default
              label="DESCRIÇÃO"
              :value="service ? service.description : 'SELECIONE O SERVIÇO'"
              disabled
            />
          </div>
          <div class="col-md-4" v-if="permission('read', 'financial')">
            <v-text-field-default
              label="CATEGORIA DO FINANCEIRO"
              :value="
                service
                  ? service.finance_configuration_category_name
                    ? service.finance_configuration_category_name
                    : 'NÃO INFORMADO'
                  : 'SELECIONEO SERVIÇO'
              "
              disabled
            />
          </div>
          <div class="col-md-4">
            <v-select-default
              item-text="description"
              item-value="id"
              :items="[
                { id: 'CUSTO', description: 'CUSTO' },
                { id: 'LUCRO', description: 'LUCRO' },
              ]"
              label="O QUE VAI ALTERAR?"
              v-model="change"
              @change="handleChange"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <v-text-field-default
              label="VALOR ATUAL"
              v-model="cost_value"
              @input="handleInputCostValue"
              :disabled="change == 'LUCRO'"
            />
          </div>
          <div class="col-md-3">
            <v-text-field-default
              label="PORCENTAGEM DE REAJUSTE(%)"
              v-model="profit"
              @input="handleInputProfit"
              :disabled="change == 'CUSTO'"
            />
          </div>
          <div class="col-md-3">
            <v-text-field-default
              label="NOVO VALOR (REAJUSTADO)"
              v-model="sale_value"
              @input="handleInputSaleValue"
              :disabled="change == 'CUSTO'"
            />
          </div>
          <div class="col-md-3">
            <v-text-field-default
              label="DATA DO REAJUSTE"
              v-model="date"
              type="date"
            />
          </div>
          <div class="col-md-12">
            <errors-messages :errors="errors" />
          </div>
          <div class="col-md-12 text-right">
            <v-btn-save
              :disabled="loading"
              :loading="loading"
              @click="execute"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row v-clean mt-2">
      <div class="col-md-12">
        <h1 class="title-pages">ÚLTIMOS REAJUSTES</h1>
        <b-overlay :show="loadingLastReleases" opacity="0.99">
          <div class="v-clean p-5 text-center" v-if="last_releases.length == 0">
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <v-data-table
            dense
            v-show="last_releases.length > 0"
            :headers="[
              { text: 'EXECUTADO?', value: 'executed', sortable: false },
              { text: 'QUEM FEZ', value: 'user', sortable: false },
              {
                text: 'SERVIÇO',
                value: 'service',
                sortable: false,
              },
              { text: 'O QUE VAI ALTERAR?', value: 'change', sortable: false },
              { text: 'VALOR (CUSTO)', value: 'cost_value', sortable: false },
              { text: 'VALOR (LUCRO)', value: 'sale_value', sortable: false },
              { text: 'DATA DO REAJUSTE', value: 'date', sortable: false },
              {
                text: 'QUANDO FOI CRIADO',
                value: 'created_at',
                sortable: false,
              },
            ]"
            :items="last_releases"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickLastReleases"
          >
            <template v-slot:[`item.executed`]="{ item }">
              <div
                v-if="item.executed == 1"
                class="d-flex align-items-center justify-content-center"
              >
                <span>SIM</span>
                <v-icon class="ml-2" small color="success">
                  mdi-check-circle-outline
                </v-icon>
              </div>
              <div
                v-else
                class="d-flex align-items-center justify-content-center"
              >
                <span>NÃO</span>
                <v-icon class="ml-2" small color="orange">
                  mdi-information-outline
                </v-icon>
              </div>
            </template>
            <template v-slot:[`item.user`]="{ item }">
              {{
                professionalClassCouncilValue({
                  id: item.user_professional_class_council_id,
                  name: item.user_name,
                  profile: item.user_profile_name,
                  office: item.user_office,
                  cpf: item.user_cpf,
                  value: item.user_professional_class_council_value,
                })
              }}
            </template>
            <template v-slot:[`item.service`]="{ item }">
              {{ item.service_description }}
            </template>
            <template v-slot:[`item.change`]="{ item }">
              {{ item.change }}
            </template>
            <template v-slot:[`item.cost_value`]="{ item }">
              R$ {{ formatPrice(item.cost_value) }}
            </template>
            <template v-slot:[`item.sale_value`]="{ item }">
              R$ {{ formatPrice(item.sale_value) }}
            </template>
            <template v-slot:[`item.date`]="{ item }">
              {{ moment(item.date).format("DD/MM/YYYY") }}
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              {{ moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") }}
            </template>
          </v-data-table>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";
import VSelectDefault from "../../../Components/VSelectDefault.vue";
import VTextFieldDefault from "../../../Components/VTextFieldDefault.vue";
import VBtnSave from "../../../Components/VBtnSave.vue";
import ConfirmationDialog from "../../../Components/ConfirmationDialog.vue";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import moment from "moment";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import permission from "../../../../lib/permission";

export default {
  name: "Services",

  components: {
    ErrorsMessages,
    VSelectDefault,
    VTextFieldDefault,
    VBtnSave,
    ConfirmationDialog,
  },

  data() {
    return {
      last_releases: [],
      last_releases_item: null,

      services: [],
      service: null,

      change: "CUSTO",

      service_id: "",

      date: "",
      cost_value: "",
      sale_value: "",
      profit: "",

      loading: false,
      loadingLastReleases: false,
      loadingDelete: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatPrice,
    permission,
    professionalClassCouncilValue,
    moment,

    handleClickLastReleases(item) {
      this.last_releases_item = item;
      this.$bvModal.show("last_releases");
    },

    handleInputProfit(value) {
      let { cost_value } = this;

      if (value) {
        let profit = formatValueToPercentage(value);
        if (profit) {
          let current = formatValueToOnlyNumber(cost_value);
          let percentage = profit * current;
          let sale_value = percentage / 100;
          sale_value = parseFloat(sale_value) + parseFloat(current);
          this.sale_value = formatPrice(sale_value);
        }
      } else {
        this.sale_value = formatPrice(0);
      }
    },

    handleInputCostValue(value) {
      this.cost_value = formatValueOnKeyUp(value);
    },

    handleInputSaleValue(value) {
      this.sale_value = formatValueOnKeyUp(value);
    },

    handleChange() {
      let { service } = this;

      if (service) {
        let { sale_price, service_cost } = service;

        this.cost_value = formatPrice(service_cost);
        this.sale_value = formatPrice(sale_price);
      } else {
        this.service = null;
        this.cost_value = "";
        this.sale_value = "";
      }
    },

    handleChangeServiceId(service) {
      this.date = "";

      if (service) {
        let { id, sale_price, service_cost, profit } = service;

        this.service_id = id;

        this.cost_value = formatPrice(service_cost);
        this.sale_value = formatPrice(sale_price);
        this.profit = profit;
        this.service = service;
      } else {
        this.service = null;
        this.cost_value = "";
        this.sale_value = "";
        this.profit = "";
      }
    },

    retrieve() {
      this.getServices();
      this.getLastReleases();
    },

    async getServices() {
      try {
        const response = await api.get("rest-home/service/paginate");

        const { error, errors, services } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.services = services;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getLastReleases() {
      try {
        this.loadingLastReleases = true;

        let { service_id } = this;

        const params = { service_id, type: "SERVICO", limit: 25 };

        const response = await api.get("/rest-home/readjustment/last", {
          params,
        });

        const { error, errors, readjustment } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.last_releases = readjustment;
        }

        this.loadingLastReleases = false;
      } catch (error) {
        console.log(error);
      }
    },

    async execute() {
      try {
        this.loading = true;

        let { service_id, date, cost_value, sale_value, profit, change } = this;

        const params = {
          service_id,
          date,
          cost_value,
          sale_value,
          profit,
          change,
        };

        const response = await api.post(
          "/rest-home/readjustment/service",
          params
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.service_id = "";
          this.date = "";
          this.cost_value = "";
          this.profit = "";
          this.sale_value = "";
          this.service = null;
          this.change = "CUSTO";
          this.getLastReleases();
        }

        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async deleteReadjustment() {
      try {
        this.loadingDelete = true;

        const {
          last_releases_item: { id },
        } = this;

        let data = { id };

        const response = await api.delete("/rest-home/readjustment", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.getLastReleases();
          toast(message, "success");
          this.$bvModal.hide("last_releases");
        } else {
          this.errors = errors;
        }

        this.loadingDelete = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
